<template lang='pug'>
  .box.mt-4
    .text-right
      b-btn(variant='primary' @click='directToAdd').mr-2
        | Lisa uus kampaania
    //- Table
    b-table.mt-3(
      :items='campaignConfigurationsProvider'
      :fields='fields'
      :per-page='rowsPerPage'
      :current-page='currentPage'
      ref='campaignConfigurationsTable'
      hover
      striped
      small
      responsive
    )
      template(v-slot:cell(isTotalEndpointAllowed)='item')
          | {{ item.value ? 'Jah' : 'Ei' }}

      template(v-slot:cell(isContributorsEndpointAllowed)='item')
          | {{ item.value ? 'Jah' : 'Ei' }}

      template(v-slot:cell(campaignCode)='{item, value}')
        router-link(:to="{ name: 'edit-campaign-configuration', params: { id: item.id, campaignConfiguration: item, mode: 'edit'} }") {{ value }}

    //- Pagination
    b-pagination(align='center' :total-rows='totalRows'
      :per-page='rowsPerPage' v-model='currentPage')
</template>

<script>
import { authBackend } from '../api'

const rowsPerPage = 20

export const fields = [
  { key: 'campaignCode',
    label: 'Kampaania kood'
  },
  { key: 'oneOffDonationSmailyCode',
    label: 'Ühekordse annetuse Smaily kood'
  },
  { key: 'recurringDonationSmailyCode',
    label: 'Korduva annetuse Smaily kood'
  },
  { key: 'signatureSmailyCode',
    label: 'Allkirja Smaily kood'
  },
  { key: 'isTotalEndpointAllowed',
    label: 'Kas kampaania summa küsimine on lubatud?'
  },
  { key: 'isContributorsEndpointAllowed',
    label: 'Kas annetajate arvu küsimine on lubatud?'
  },
  { key: 'oneOffDonationReturnUrl',
    label: 'Ühekordse annetuse tagasipöördumise aadress'
  },
  { key: 'recurringDonationDescription',
    label: 'Korduva annetuse kirjeldus'
  },
  { key: 'facebookPixelId',
    label: 'Facebook Pixel ID'
  },
  { key: 'facebookCapiAccessToken',
    label: 'Facebook CAPI ligipääsuluba (access token)'
  },
  { key: 'facebookTestEventCode',
    label: 'Facebook CAPI testsündmuse kood (test event code)'
  },
  { key: 'isTaimneTeisipaev',
    label: 'Taimse Teisipäeva kampaania'
  }
]

export default {
  name: 'campaignConfigurations',

  data() {
    return {
      fields,
      currentPage: 1,
      rowsPerPage,
      totalRows: 0,
      campaignConfigurations: []
    }
  },

  methods: {

    async fetchCampaignConfiguration() {
      const campaignConfigurationData = (
        await authBackend().get('/api/campaign_configuration', { params:
          {
            page: this.currentPage - 1
          }
        })
      ).data

      this.totalRows = campaignConfigurationData.totalRows

      this.campaignConfigurations = campaignConfigurationData.campaignConfigurations

      return campaignConfigurationData.campaignConfigurations
    },

    campaignConfigurationsProvider(ctx, callback) {
      this.fetchCampaignConfiguration().then(callback)
    },

    refreshTable() {
      this.$refs.campaignConfigurationsTable.refresh()
    },

    directToAdd() {
      this.$router.push({ name: 'add-campaign-configuration', params: { mode: 'add' } })
    }

  }
}
</script>

<style lang="scss">

</style>
